import { render, staticRenderFns } from "./ed-section-projects-object.vue?vue&type=template&id=a3ed727c&scoped=true&"
import script from "./ed-section-projects-object.ts?vue&type=script&lang=ts&"
export * from "./ed-section-projects-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-projects-object.scss?vue&type=style&index=0&id=a3ed727c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ed727c",
  null
  
)

export default component.exports